<template>
  <div class="forgot-password d-flex align-items-center justify-content-center min-vh-100">
    <div class="forgot-password-container p-5 rounded shadow-lg">
      <h2 class="text-center mb-4">Forgot Password</h2>
      <p class="text-center text-muted mb-4">Please enter your email address. We’ll send your new password.</p>
      
      <form v-if="!message" @submit.prevent="handleForgotPassword">
        <div class="mb-4">
          <label for="email" class="form-label">Email address</label>
          <input 
            type="email" 
            class="form-control form-control-lg" 
            id="email" 
            v-model="email" 
            required 
            placeholder="Enter your email"
          >
          <div v-if="emailError" class="text-danger mt-2">{{ emailError }}</div>
        </div>
        <button type="submit" class="btn btn-primary btn-lg w-100">Reset</button>
      </form>

      <div v-if="message" class="text-center mt-4">
        <p class="text-success">{{ message }}</p>
        <button @click="goBack" class="btn btn-link">Return to Login</button>
      </div>

      <div v-if="error" class="text-danger text-center mt-3">{{ error }}</div>

      <div v-if="!message" class="text-center mt-4">
        <a href="#" @click.prevent="goBack" class="text-muted">Back to Login</a>
      </div>
    </div>
  </div>
</template>

<script>
import { AuthService } from '@/Services/AuthService';
import { useRouter } from 'vue-router';

export default {
  name: "ForgotPassword",
  data() {
    return {
      email: '',
      emailError: null,
      message: null,
      error: null,
    };
  },
  setup() {
    const router = useRouter();
    return { router };
  },
  methods: {
    async handleForgotPassword() {
      this.emailError = null;
      this.message = null;
      this.error = null;

      if (!this.email) {
        this.emailError = "Email is required.";
        return;
      }

      try {
        const response = await AuthService.forgotPassword({ email: this.email });
        if (response.success) {
          this.message = "A password reset link has been sent to your email.";
          this.router.push({ name: 'loginPage' });
        } else {
          this.error = response.message || "Failed to send reset link. Please try again.";
        }
      } catch (error) {
        this.error = "An error occurred. Please try again.";
        console.error("Forgot password failed:", error);
      }
    },
    goBack() {
      this.router.push({ name: 'loginPage' });
    }
  }
};
</script>

<style scoped>
.forgot-password-container {
  max-width: 400px;
  width: 100%;
  background-color: #fff;
}

.forgot-password {
  background-color: #f0f2f5;
}

h2 {
  font-weight: bold;
  color: #333;
}

.btn-primary {
  background-color: #007bff;
  border-color: #007bff;
}

.btn-primary:hover {
  background-color: #0056b3;
  border-color: #0056b3;
}

.text-muted {
  color: #6c757d !important;
}

a.text-muted:hover {
  color: #333 !important;
}

.text-danger {
  color: red;
}

.text-success {
  color: green;
}
</style>
